import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";

const Environment = true;

export const GlobalUrl =
  Environment === true
    ? "https://api.data-ignite.com:2053"
    : "https://api.data-ignite.com:2083"; // Default for development/preprod
    // : "http://localhost:8000"; // Default for development/preprod

export const apiBasePath =
  Environment === true ? "/auth/prod-tenant" : "/auth/test-tenant";

export const sasToken =
  Environment === true
    ? "sp=racw&st=2025-03-17T09:42:58Z&se=2025-12-31T17:42:58Z&sv=2022-11-02&sr=c&sig=A9l8xiYGQ9r%2FUxOhx3K0W7daR4Iac61x782PplE1aBo%3D"
    : "sp=racw&st=2025-03-17T09:37:12Z&se=2025-12-31T17:37:12Z&sv=2022-11-02&sr=c&sig=SalhiLJvlErjiGSjH1HO3cjCChxnRpjLwVPQ8r5hT%2BM%3D";

export const containerName =
  Environment === true ? "prod-ignite-files" : "test-ignite-files";

export const drawerWidth = 260;

export const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

export const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  // backgroundColor: "#1A202C",
  // color: "#FFFFFF",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      // backgroundColor: "#1A202C",
      // color: "#FFFFFF",
      // boxShadow: "2px 0px 5px rgba(0, 0, 0, 0.3)"
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      backgroundColor: "#1A202C", // Apply the same background color when closed
      color: "#FFFFFF",
      boxShadow: "2px 0px 5px rgba(0, 0, 0, 0.3)",
    },
  }),
}));
